import { Site } from '@debbie/common/dist/index.js';
import { UpdateReferenceTypes, } from '@debbie/common/dist/updates/index.js';
import { uniqueBy } from '@debbie/common/dist/util/index.js';
import { ActivityType, } from '@debbie/common/dist/web-sockets/index.js';
import { prefetchCaseData } from '@debbie/cortex/dist/cases/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import AdvancedFilter from '../Filter/AdvancedFilter.js';
import { ArrowLeft, Filter as FilterIcon, Maximize2, Minimize2, } from '../Icons/index.js';
import { Button, ButtonGroup, Modal } from '../index.js';
import UpdateTypeLabel from '../UpdateTypeLabel.js';
import ListItem from './ListItem.js';
import TodoBulkActions from './TodoBulkActions.js';
var Sorting;
(function (Sorting) {
    Sorting["OldestFirst"] = "OLDEST_FIRST";
    Sorting["BestOpportunity"] = "BEST_OPPORTUNITY";
})(Sorting || (Sorting = {}));
let tId;
const Queue = (props) => {
    const history = useHistory();
    const { updateType, id } = props;
    const caseFilter = useCaseFilter();
    const tenant = useTenant();
    const [sorting, _setSorting] = useState(localStorage.getItem('sortingTodoQueue') || Sorting.BestOpportunity);
    const [checkedUpdates, setCheckedUpdates] = useState({});
    const [clickedNext, setClickedNext] = useState(false);
    const [showMax, setShowMax] = useState(100);
    const setSorting = (sorting) => {
        localStorage.setItem('sortingTodoQueue', sorting);
        _setSorting(sorting);
    };
    const allUpdates = useMemo(() => {
        return sorting === Sorting.BestOpportunity
            ? props.updates
            : [...props.updates].sort((a, b) => new Date(a.pausedAt).getTime() - new Date(b.pausedAt).getTime());
    }, [props.updates, sorting]);
    const updates = uniqueBy(allUpdates, (u) => u.referenceId);
    const [selectedIndex, setSelectedIndex] = useState(updates.length ? 0 : null);
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const activeUsers = useSelector((s) => s.activeUsers);
    const [minimized, _setMinimized] = useState(!!localStorage.getItem('queuedTodoPanelMinimized'));
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const setQueuedTodoPanelMinimized = (s) => {
        localStorage.setItem('queuedTodoPanelMinimized', s ? 'true' : '');
        _setMinimized(s);
    };
    useEffect(() => {
        if (props.onMinimize) {
            props.onMinimize(minimized);
        }
    }, [minimized]);
    useEffect(() => {
        if (tenant?.settings?.aiDisabled) {
            setSorting(Sorting.OldestFirst);
        }
    }, [tenant]);
    const usersOnCaseMap = Object.values(activeUsers).reduce((acc, users) => {
        for (let i = 0; i < users.length; i++) {
            const user = users[i];
            for (let f = 0; f < user.activities.length; f++) {
                const activity = user.activities[f];
                if (activity.type === ActivityType.WATCHINGCASE) {
                    if (!acc[activity.handle]) {
                        acc[activity.handle] = [];
                    }
                    acc[activity.handle] = acc[activity.handle].concat({
                        user,
                        data: activity.data,
                    });
                }
            }
        }
        return acc;
    }, {});
    const nextTodo = getNextTodo(updates, selectedIndex, usersOnCaseMap, id);
    useEffect(() => {
        if (updates && updateType && !id) {
            const next = getNextTodo(updates, selectedIndex, usersOnCaseMap, id);
            if (next) {
                c.redirect.redirect(`/todo-queue/${updateType.updateTypeId}/${next.referenceId}`, {
                    preserveQuery: true,
                    replace: true,
                });
            }
        }
    }, [allUpdates, updateType, id]);
    useEffect(() => {
        const _selectedIndex = updates.findIndex((u) => u.referenceId === id);
        if (_selectedIndex !== -1) {
            setSelectedIndex(_selectedIndex);
        }
    }, [id, sorting, allUpdates]);
    const nextBufferTime = 2000;
    useEffect(() => {
        const selectedUpdate = updates.find((update) => update.referenceId === id);
        if (clickedNext &&
            props.loadTimestamp &&
            Date.now() - props.loadTimestamp < nextBufferTime &&
            selectedUpdate != null &&
            selectedUpdate.type === UpdateReferenceTypes.CASE &&
            usersOnCaseMap[selectedUpdate.details.caseSeqId] != null &&
            usersOnCaseMap[selectedUpdate.details.caseSeqId].find((u) => u.data.timestamp < props.loadTimestamp) &&
            nextTodo) {
            c.redirect.redirect(`/todo-queue/${updateType.updateTypeId}/${nextTodo.referenceId}`, {
                preserveQuery: true,
            });
        }
    }, [id, clickedNext, props.loadTimestamp, activeUsers]);
    const selectable = true;
    const queueCaseFilter = {
        hasCurrentPauseIds: [props.updateType.updateTypeId],
    };
    return (React.createElement(NextCaseStyled, { minimized: minimized },
        React.createElement("div", { onClick: () => setQueuedTodoPanelMinimized(!minimized), style: { cursor: 'pointer', textAlign: 'right' } }, minimized ? React.createElement(Maximize2, null) : React.createElement(Minimize2, null)),
        !minimized && (React.createElement("p", { style: { marginBottom: '0px', fontSize: '.7em' } },
            React.createElement("b", null, lang.todoQueue.sorting),
            ' ',
            React.createElement("span", { style: { float: 'right' } },
                React.createElement("span", { onClick: () => setSorting(Sorting.OldestFirst), style: {
                        cursor: 'pointer',
                        textDecoration: sorting === Sorting.OldestFirst ? 'underline' : undefined,
                    } }, lang.todoQueue.oldest),
                ' ',
                "/",
                ' ',
                React.createElement("span", { onClick: () => setSorting(Sorting.BestOpportunity), style: {
                        cursor: 'pointer',
                        textDecoration: sorting === Sorting.BestOpportunity ? 'underline' : undefined,
                    } }, lang.todoQueue.creditScore)))),
        React.createElement("h3", { style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                marginBottom: '1em',
                fontSize: minimized ? '0.8em' : '0.9em',
            } },
            React.createElement("b", null,
                React.createElement(UpdateTypeLabel, { updateTypeId: updateType.updateTypeId, label: updateType.label }))),
        !minimized && (React.createElement(React.Fragment, null,
            selectable && (React.createElement(TodoBulkActions, { updates: allUpdates, checkedUpdates: checkedUpdates, setCheckedUpdates: setCheckedUpdates, caseFilter: { ...caseFilter, ...queueCaseFilter } })),
            React.createElement(List, { onScroll: (e) => {
                    // Make sure React do not re-render to often
                    const showMore = e.target.scrollHeight -
                        e.target.getBoundingClientRect().height -
                        e.target.scrollTop <
                        100;
                    if (showMore) {
                        clearTimeout(tId);
                        tId = setTimeout(() => {
                            setShowMax(showMax + 200);
                        }, 100);
                    }
                } }, updates.slice(0, showMax).map((update) => {
                const selected = update.referenceId === id;
                return (React.createElement(ListItem, { key: update.referenceId, selected: selected, update: update, updateType: updateType, usersOnCaseMap: usersOnCaseMap, checked: !!checkedUpdates[update.referenceId], setClickedNext: setClickedNext, onCheck: (checked) => {
                        if (checked) {
                            setCheckedUpdates({
                                ...checkedUpdates,
                                [update.referenceId]: true,
                            });
                        }
                        else {
                            checkedUpdates[update.referenceId] = false;
                            setCheckedUpdates(checkedUpdates);
                        }
                    } }));
            })))),
        React.createElement("p", { style: {
                fontSize: '.8em',
            } }, Site.Caseworker === site ? (React.createElement("span", null,
            typeof selectedIndex === 'number' ? `${selectedIndex + 1} / ` : '',
            updates.length,
            ' ',
            updateType.referenceType === UpdateReferenceTypes.CASE && (React.createElement(FilterIcon, { style: { cursor: 'pointer' }, onClick: () => setFilterModalOpen(!filterModalOpen) })))) : (' ')),
        nextTodo && (React.createElement(ButtonGroup, null,
            React.createElement(Button, { theme: "secondary", size: "mini", onClick: () => {
                    setClickedNext(false);
                    history.goBack();
                } },
                React.createElement(ArrowLeft, { style: {
                        verticalAlign: 'middle',
                        height: '0.9em',
                    } })),
            React.createElement(Button, { size: "mini", onMouseEnter: () => {
                    prefetchCaseData(nextTodo.referenceId);
                }, onClick: () => {
                    c.redirect.redirect(`/todo-queue/${updateType.updateTypeId}/${nextTodo.referenceId}`, {
                        preserveQuery: true,
                    });
                    setClickedNext(true);
                } }, lang.outboundPhone.nextCase))),
        filterModalOpen && (React.createElement(Modal, { onToggle: () => setFilterModalOpen(!filterModalOpen), header: lang.caseFilter.advancedFilters },
            React.createElement(AdvancedFilter, { caseFilter: queueCaseFilter, hidePaginationGroup: true })))));
};
export default Queue;
const getNextTodo = (updates, selectedIndex, usersOnCaseMap, id) => {
    if (selectedIndex === null) {
        return updates[0] || null;
    }
    else {
        const nextUpdates = [updates[selectedIndex]].concat(updates.slice(selectedIndex + 1).filter((update) => {
            const usersOnCase = update.type === UpdateReferenceTypes.CASE &&
                usersOnCaseMap[update.details.caseSeqId];
            return !usersOnCase;
        }));
        const currentUpdate = updates.find((update) => update.referenceId === id);
        if (!currentUpdate) {
            return nextUpdates[0] || updates[0] || null;
        }
        else {
            return nextUpdates[1] || updates[0] || null;
        }
    }
};
const List = styled.div `
  max-height: calc(100vh - ${125 + THEME.NAV_TOP_HEIGHT + 110}px);
  overflow-y: scroll;
  font-size: 0.8em;

  position: relative;
`;
const NextCaseStyled = styled.div `
  position: absolute;
  z-index: 3;
  bottom: ${(props) => (props.minimized ? 100 : 5)}px;
  ${(props) => props.minimized
    ? `
        right: 5px;
        box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
      `
    : `
        right: 5px;
        top: ${THEME.NAV_TOP_HEIGHT + 5}px;

      `}

  border-radius: 2px;

  background-color: ${THEME.COLOR_SECONDARY};
  padding: 10px;
  width: ${(props) => (props.minimized ? 165 : 250)}px;
`;
//# sourceMappingURL=Queue.js.map